export default __webpack_public_path__ + "static/media/material_large.c56fbdd0.png";